module.exports = __webpack_public_path__ + "static/media/hpra.6061b12c.png";